import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const useStyles = makeStyles((theme) => ({
  btnIcon: {
    color: theme.palette.text.primary,
    fontSize: 20,
  },
}));

interface ActionElementProps {
  icon: IconProp;
  handleOnClick: () => void;
  color?: string;
}

const ActionElement: React.FC<ActionElementProps> = ({ handleOnClick, icon, color }) => {
  const classes = useStyles();
  return (
    <IconButton onClick={() => handleOnClick()}>
      <FontAwesomeIcon
        icon={icon}
        className={classes.btnIcon}
        style={color ? { color } : undefined}
      />
    </IconButton>
  );
};

export default ActionElement;
